/* @flow */
import * as React from 'react';
import ReactDOMServer from 'react-dom/server';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';
import striptags from 'striptags';
import type { TranslatorProps } from 'react-i18next';

import type TypeForm from 'forms/_.extend';

import Loading from 'components/Loading/Loading';

import SiteAddress from 'components/SiteAddress/SiteAddress';
import ElectroTextField from 'forms/components/inputs/ElectroTextField/ElectroTextField';
import ActionDrawerFormButtons from 'views/ActionDrawer/components/ActionDrawerFormButtons/ActionDrawerFormButtons';
import ActionDrawerBlock from 'views/ActionDrawer/components/ActionDrawerBlock/ActionDrawerBlock';
import ActionDrawerTable from 'views/ActionDrawer/components/ActionDrawerTable/ActionDrawerTable';

import styles from '../../../../ActionDrawer.module.scss';

type TypeProps = {|
  location: Object,
  form: TypeForm,
  accountStore: Object,
|} & TranslatorProps;

@translate()
@inject('accountStore')
@observer
export default class UnarchiveLocationForm extends React.Component<*> {
  render(): React.Node {
    const { t, location, form, accountStore }: TypeProps = this.props;

    const locationDetails: Object = location.hierarchy ? location : accountStore.locationDetails;

    const details: Array<*> = [
      [t('general:company'), location.company ? location.company.name : location.company_name],
    ];

    if (locationDetails) {
      if (locationDetails.hierarchy.site) {
        if (locationDetails.hierarchy.site.name) {
          details.push([t('general:locations.labels.site'), locationDetails.hierarchy.site.name]);
        }

        if (locationDetails.hierarchy.site.address) {
          details.push([
            t('general:locations.labels.site_address'),
            striptags(
              ReactDOMServer.renderToString(
                <SiteAddress key="site_address" {...locationDetails.hierarchy.site.address} />
              )
            ),
          ]);
        }
      }

      if (locationDetails.hierarchy.building && locationDetails.hierarchy.building.name) {
        details.push([
          t('general:locations.labels.building_transport'),
          locationDetails.hierarchy.building.name,
        ]);
      }

      if (locationDetails.hierarchy.room && locationDetails.hierarchy.room.name) {
        details.push([t('general:locations.labels.lab_room'), locationDetails.hierarchy.room.name]);
      }

      if (locationDetails.hierarchy.workspace && locationDetails.hierarchy.workspace.name) {
        details.push([
          t('general:locations.labels.system_workspace'),
          locationDetails.hierarchy.workspace.name,
        ]);
      }
    }

    if (!accountStore.locationDetails) {
      return <Loading />;
    }

    return (
      <React.Fragment>
        <div className={styles['action-drawer-content']}>
          <ActionDrawerBlock
            divider={true}
            gutters={true}
            heading={t('general:locations.labels.details')}
          >
            <ActionDrawerTable data={details} />
          </ActionDrawerBlock>
          <ActionDrawerBlock gutters={true} heading={form.$('unarchiveReason').label}>
            <h5>{`${t('general:reasons.provide_reason')} *`}</h5>
            <ElectroTextField
              field={form.$('unarchiveReason.reason')}
              props={{
                rows: 3,
                multiline: true,
                label: '',
              }}
            />
          </ActionDrawerBlock>
        </div>
        <ActionDrawerFormButtons form={form} submitTxt={t('general:actions.unarchive')} />
      </React.Fragment>
    );
  }
}
